import '@/helpers/auth';
import i18n from '@/providers/i18n'
import {differenceInHours, differenceInDays} from 'date-fns'
import * as cookies from '@/helpers/cookies'
import Vue from 'vue'
import Vuex from 'vuex'
import Recordset from '@/providers/api/Recordset'
import Client from '@/providers/api/Client';
import AsyncComputed from 'vue-async-computed';
import ModalDialogs from 'vue-modal-dialogs'
import Wizard from '@/helpers/components/display/Wizard'

const GDPR_PROMPT_ID = 1;
const DAYS_BEFORE_LOCK = 14;

const GDPRdialog = ModalDialogs.makeDialog(
  {
    components: {Wizard},
    props: {document: {required:true}},
    template:
      '<Wizard class="message sm" :logo=false> \
        <h3>{{ document.title }}</h3> \
        <div v-html="document.content" class=text></div> \
        <nav class="actions"> \
          <button class="btn lg" @click="$close(true)">\
            {{ "buttons.agree_terms" | trans }}\
          </button> \
          <button class="btn lg inverse" @click="$close(false)">\
            {{ "buttons.reject_terms" | trans }}\
          </button> \
          <p class="state-error"><small>{{ "reject_warning" | trans }}</small></p>\
        </nav> \
      </Wizard>',
  },
  'document'
);

Vue.use(AsyncComputed)
Vue.use(Vuex);
const context = new Vuex.Store({
  state: {
    auth: localStorage.getItem('auth-token') || false,
    user: undefined,
    apptoken: undefined,
    billing_plan: undefined,
    titles: {},
    prompts: {},
    //timezone: sessionStorage.getItem('timezone') || false,,
  },
  mutations: {
    login (state, auth) {
      cookies.eraseCookie(cookies.names.admin);
      state.auth = auth;
      localStorage.setItem('auth-token', auth);
      this.commit('refresh');
    },
    choose_apptoken (state, token) {
      if (token) {
        state.apptoken = token;
      }
    },
    refresh (state, vars = {}) {
      if (state.auth) {
        //reset confirmed prompts info
        state.prompts = {};
        if (vars.hasOwnProperty('user')) {
          state.user = vars.user;
        } else {
          //get user
          this.getters.api
            .get('users/me?range=single')
            //GDPR - user has to agree to proceed
            // .then(user =>
            //   //Search for already accepted GDPR text
            //   this.getters.api
            //     .get('prompts_confirmations' +
            //       '?filter=prompts_id::eq::' + GDPR_PROMPT_ID +
            //         ',confirmed::eq::1' +
            //         ',users_id::eq::' + user.id +
            //       '&range=single'
            //     )
            //     .then(p => p.length ?
            //       //if user has already agreed, proceed normally (forward user)
            //       user :
            //       //otherwise get and display prompt text
            //       this.getters.api
            //         .get('prompts/' + GDPR_PROMPT_ID)
            //         .then(prompt => GDPRdialog(prompt.resource))
            //         .then(accepted => {
            //           if (accepted) {
            //             //mark prompt as confirmed and forward user
            //             return this.getters.api
            //               .post('prompts_confirmations', {
            //                 confirmed: 1,
            //                 prompts_id: GDPR_PROMPT_ID,
            //                 users_id: user.id,
            //               })
            //               .then(() => user)
            //             ;
            //           } else {
            //             throw new Error('GDPR rejected');
            //           }
            //         })
            //     )
            // )
            .then(user => state.user = user)
            .catch((e) => {
              state.user = new Recordset('users', []);
              throw e;
            })
          ;
        }
        var getApptoken;
        if (vars.hasOwnProperty('apptoken')) {
          state.apptoken = vars.apptoken;
          getApptoken = new Promise(r => r(state.apptoken));
        } else {
          getApptoken = this.getters.api
            .get('apptokens/me?range=single')
            .then(apptoken => state.apptoken = apptoken)
            .catch(e => {
              state.apptoken = new Recordset('apptokens', []);
              throw e;  //to stop .then() chaining
            });
        }

        if (vars.hasOwnProperty('billing_plan')) {
          state.billing_plan = vars.billing_plan;
        } else {
          state.billing_plan = undefined;
          getApptoken.then(apptoken => Promise.all([
              this.getters.api.get(
                'billings_contracts?' +
                'include=signed_tos,billings_plans,billings&' +
                'filter=active::eq::1,apptokens_id::eq::' + apptoken.id
              ),
              this.getters.api.get(
                'billings?' +
                'filter=apptokens_id::eq::' + apptoken.id + '&' +
                'include=billings_transactions'
              )
            ]))
            .then(([r, billings]) => {
              if (r.length > 1) {
                r.sort('locked', false);
                return r.pluck();
              }
              return [r, billings];
            })
            .then(([r, billings]) => {
              r.set('billings', billings.filter(b => Number(b.billings_contracts_id) === Number(r.id)));
              r.set('other_billings', billings.filter(b => Number(b.billings_contracts_id) !== Number(r.id)));
              r.set('invoices', billings.filter(b => Number(b.invoice) !== 0));
              return r;
            })
            .then(plan => state.billing_plan = plan)
            .catch(() => state.billing_plan = new Recordset('billings_plans', []))
          ;
        }
      } else {
        this.commit('logout');
      }
    },
    logout (state) {
      cookies.eraseCookie(cookies.names.admin);
      state.auth = false;
      state.user = new Recordset('users', []);
      state.apptoken = new Recordset('apptokens', []);
      state.billing_plan = new Recordset('billings_plans', []);
      state.prompts = {};
      localStorage.clear();
    },
    setTitle (state, routeTitle) {
      var [routeName, title] = routeTitle;
      Vue.set(state.titles, routeName, title);
    },
    prompt (state, prompt_title) {
      Vue.set(state.prompts, prompt_title, 1);
    },
  },
  getters: {
    logged: state => state.auth,
    api: (state, storegetters) => {
      //Extend original Client call to catch expired auth token
      var self = this;
      var client = new Client(state.auth);
      var originalCall = client.call;
      client.call = function () {
        return originalCall
          .apply(client, arguments)
          .catch(function (e) {
            if (e.hasOwnProperty('code')) {
              switch (e.code) {
                //Auth token expired
                case 4003:
                //User with the given auth-token does not exist.
                //case 4500:
                  if (typeof context.commit === 'function') {
                    context.commit('logout');
                  } else if (typeof self.a.commit === 'function') {
                    self.a.commit('logout');
                  } else if (typeof self.commit === 'function') {
                    self.commit('logout');
                  } else if (typeof self.b.commit === 'function') {
                    self.b.commit('logout');
                  }
                  return [];
                  break;
                //User request limit reached
                case 4215:
                  alert('User request limit reached');
                  return [];
                  break;
              }
            }
            throw e;
          })
        ;
      };
      //Extend original Client call to catch mismatched apptoken
      var originalGet = client.get;
      client.unguarded = originalGet;
      client.get = function () {
        return originalGet
          .apply(client, arguments)
          .then(r => {
            if (
              !storegetters.admin &&
              state.apptoken &&
              r.length &&
              r.apptokens_id &&
              Number(r.apptokens_id) !== state.apptoken.id &&
              (!r.users_id || Number(r.users_id) !== Number(state.apptoken.users_id))
            ) {
              throw new Error('Permission denied for ' + r._type + ' by proxy client in context. Apptoken or user do not match.');
            } else {
              return r;
            }
          })
        ;
      }
      return client;
    },
    unpaid: state => {
      if (!state.billing_plan) {
        return undefined;
      }
      var invoices = state.billing_plan.invoices;
      var min_days = 'paid';
      if (!invoices || !invoices.length) {
        return undefined;
      }
      for (let invoice of invoices) {
        let days_remain = compute_invoice(invoice).days_remain;
        if (days_remain === true) {
          return 'locked';
        }
        if (days_remain && (min_days === 'paid' || days_remain < min_days)) {
          min_days = days_remain === true ? 0 : days_remain;
        }
      }
      return min_days;
    },
    user: state => state.user,
    admin: state => state.user && Number(state.user.usergroups_id) === Number(ENV.GROUP_ADMIN),
    apptoken: state => state.apptoken,
    billing_plan: state => state.billing_plan,
    async: (state, storegetters) => {
      //return promise of getter
      return function (getter, forceRefresh = false) {
        if (typeof getter === 'object') {
          return Promise.all(getter.map(param => storegetters.async(param, forceRefresh)));
        }
        var current = state[getter];
        return new Promise((resolve) => {
          if (current && !forceRefresh) {
            //resolved immediately
            resolve(current);
          } else {
            if (current && forceRefresh) {
              //fetch data
              context.commit('refresh');
            }
            //resolved when data is fetched
            context.watch(
              (state) => state[getter],
              (value) => {resolve(value)}
            );
            //force get
          }
        });
      };
    },
    getTitle: state => routename => state.titles[routename],
    prompt: state => prompt_title => state.prompts[prompt_title] || false,
  },
});

Vue.mixin({
  data () {return {
    //async load
    async: (getter, f = a => a) => {
      return this.$store.getters.async(getter).then(f);
    },
  }},
  computed: {
    //make API easily accessible
    api() {
      return this.$store.getters.api;
    },
  },
});

export default context;

export function compute_invoice(invoice) {
  if (!invoice.length) {
    return invoice;
  }
  var transactions = invoice.billings_transactions;
  var counts = {ok:0 ,pending:0, fail:0};
  for (let key of Object.keys(counts)) {
    counts[key] = (transactions && transactions.list || [])
      .filter(t => t.type.toLowerCase() === key).length
    ;
  }
  if (transactions && transactions.length) {
    invoice.payment_type_name = i18n.i18next.t('billings:payment_types.' + transactions.pluck().gateway);
  } else {
    invoice.payment_type_name = '';
  }
  if (counts.ok || Number(invoice.invoice) === 2) {
    invoice.billing_status = 'paid';
  } else if (counts.pending > 1) {
    invoice.billing_status = 'not_paid';
  } else if (counts.pending === 1) {
    invoice.billing_status = 'pending';
  } else if (!counts.pending && !counts.ok) {
    invoice.billing_status = 'not_paid';
  } else {
    throw new Error('Unexpected counts of successful payments');
  }
  var transaction = invoice.billings_transactions.filter(t => t.approval_link).sort('created_at', true).pluck();
  var newNeeded = true;
  if (transaction.length) {
    //Paypal token expiration time = 3 hours (from documentation)
    newNeeded = differenceInHours(new Date(), transaction.created_at + ' UTC') > 3;
  }
  invoice.days_remain = false;
  if (invoice.billing_status === 'not_paid' || invoice.billing_status === 'pending') {
    invoice.days_remain = DAYS_BEFORE_LOCK - differenceInDays(new Date(), invoice.created_at + ' UTC');
    if (invoice.days_remain <= 0) {
      invoice.days_remain = true;
    }
  }
  if (newNeeded) {
    invoice.payment_link = 'manual';
  } else {
    invoice.payment_link = transaction.approval_link;
  }
  invoice.vat_from_cost_clean = ((invoice.cost_clean/100) * invoice.tax/100) * 100;
  invoice.cost_final_per_row = invoice.vat_from_cost_clean + invoice.cost_clean;
  return invoice;
}


// WEBPACK FOOTER //
// ./src/providers/context.js